import React from "react";

interface ToggleOffIconProps {
  style?: React.CSSProperties; // Define style as a required prop with proper typing
}

const ToggleOffIcon: React.FC<ToggleOffIconProps> = ({ style }) => {
  return (
    <svg
      style={style}
      width="65"
      height="39"
      viewBox="0 0 65 39"
      fill="none"
      xmlns="
  http://www.w3.org/2000/svg"
    >
      <g opacity="0.5">
        <rect
          x="12"
          y="12"
          width="34"
          height="14"
          rx="7"
          fill="#0075AA"
        />
      </g>
      <g filter="url(#filter0_ddd_901_127680)">
        <circle
          cx="39"
          cy="19"
          r="10"
          fill="#0075AA"
        />
      </g>
      <defs>
        <filter
          id="filter0_ddd_901_127680"
          x="26"
          y="7"
          width="26"
          height="26"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity="0"
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite
            in2="hardAlpha"
            operator="out"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_901_127680"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite
            in2="hardAlpha"
            operator="out"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_901_127680"
            result="effect2_dropShadow_901_127680"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1"
            operator="erode"
            in="SourceAlpha"
            result="effect3_dropShadow_901_127680"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite
            in2="hardAlpha"
            operator="out"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_dropShadow_901_127680"
            result="effect3_dropShadow_901_127680"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect3_dropShadow_901_127680"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default ToggleOffIcon;
